'use strict';

function getButtonGroup(buttons) {
  return {
    tag: 'div',
    attrs: {
      className: {
        'btn-group': true
      }
    },
    children: buttons
  };
};

module.exports = getButtonGroup;




/*****************
 ** WEBPACK FOOTER
 ** ./~/uvdom-bootstrap/lib/getButtonGroup.js
 ** module id = 1063
 ** module chunks = 0
 **/